module.exports = __webpack_public_path__ + "static/media/ilustration_main_clinic.e3e18298.svg";